namespace RedBullMOBILE360.Administration {
    export interface DbLinkMapForm {
        LinkAlias: Serenity.StringEditor;
        ReplaceBy: Serenity.StringEditor;
    }

    export class DbLinkMapForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.DbLinkMap';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DbLinkMapForm.init)  {
                DbLinkMapForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(DbLinkMapForm, [
                    'LinkAlias', w0,
                    'ReplaceBy', w0
                ]);
            }
        }
    }
}
